import Typography from "@mui/material/Typography"
import { styled } from "@mui/material/styles"

import Row from "../../../../../common/components/Row"

export default function TabHeaderRow({ title, children }) {
  return (
    <Container>
      <Typography variant="h4">{title}</Typography>
      {children}
    </Container>
  )
}

const Container = styled(Row)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  position: "relative",
  top: 0,
  zIndex: 1,
  backgroundColor: "transparent",
  paddingRight: theme.spacing(0.5),
  paddingBottom: theme.spacing(2),
}))
